export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11576.08ffdce5.jpg";